import React from 'react';
import { Col, Row } from 'reactstrap';
import { FlexController } from '../FlexControllerInput';

/**
 * Renderiza os campos de agendamento para a lista de transmissão de whatsapp ou de sms.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {import('react-hook-form').Control<Record<string, any>>} props.control - O `control` vindo do react-hook-form.
 * @param {boolean} props.isEnabledSchedule - Indica se o agendamento está habilitado.
 * @param {Function} props.setValue - Função para definir o valor de um campo.
 * @param {Function} props.setIsEnabledSchedule - Função para definir se o agendamento está habilitado.
 * @param {import('react-hook-form').DeepMap<Record<string, any>, import('react-hook-form').FieldError>} props.errors - Objeto de erros do react-hook-form.
 * @param {Function} props.currentDate - Função para obter a data atual.
 * @param {Object} props.hourRules - Regras de validação para o campo de hora.
 * @returns {React.ReactElement}
 */
export default function BroadcastSchedulingFields({
  control,
  isEnabledSchedule,
  setValue,
  setIsEnabledSchedule,
  errors,
  currentDate,
  hourRules
}) {
  return (
    <>
      <Row className="mb-3">
        <Col sm={12} className="d-flex align-items-center">
          <FlexController
            type="checkbox"
            control={control}
            checked={isEnabledSchedule}
            defaultValue={isEnabledSchedule}
            valueController={setValue}
            name="isEnabledSchedule"
            onChange={(e) => {
              setValue('isEnabledSchedule', e.target.checked);
              setIsEnabledSchedule(e.target.checked);
            }}
            textoDoLabel="Fazer disparo em horário e data programados (agendar disparo)?"
          />
        </Col>
      </Row>
      {isEnabledSchedule ? (
        <Row className="mb-3">
          <Col md="3">
            <FlexController
              type="date"
              control={control}
              errors={errors}
              name="sendingScheduleDate"
              textoDoLabel="Data do disparo*"
              valueController={setValue}
              defaultValue={currentDate()}
            />
          </Col>
          <Col md="3">
            <FlexController
              type="time"
              errors={errors}
              control={control}
              name="sendingScheduleTime"
              rules={hourRules}
              valueController={setValue}
              defaultValue="00:00:00"
              textoDoLabel="Horário do disparo*"
            />
          </Col>
        </Row>
      ) : null}
    </>
  );
}
